export const STU_TYPE = {
  STUDENT: 1, // 普通学生
  SSI: 3, // SSI
  VOLUNTEER: 4, // 志愿者
  TRAINEE: 8, // 管培生
  VOL_TRAINEE: 12 // 3+4
};
export const STU_TYPE_STR = {
  HIGH_SCHOOL: '中学生',
  COLLAGE: '大学生'
};
export default {
  STU_TYPE,
  STU_TYPE_STR
};
